import { gql } from "@apollo/client";

export const GET_PROVIDER_SELECT_ITEMS = gql(`
  query GetProviderSelectItems
  @permission(requires: useWebApp) {
    provider {
      id
      firstName
      lastName
      providerTypeId
    }
  }
`);

export const COMMAND_INDEX_PROVIDERS_QUERY = gql`
  query CommandIndexProviders($includeShifts: Boolean = false, $start: String, $end: String, $active: Boolean, $organizationalUnitSegmentationEnabled: Boolean = false)
  @permission(requires: useWebApp)
  {
    commandIndexProviders(where: { active: { eq: $active } }) {
      providers {
        id
        firstName
        lastName
        addressStreet
        addressLineTwo
        addressCity
        addressState
        addressZip
        addressCoordinates
        addressTimezone
        external
        providerTypeId
        providerType {
          id
          name
          requireStateLicense
        }
        traits {
          trait
          value
        }
        teamProviders {
          teamId
        }
        active
        serviceLineProviders {
          serviceLineId
          serviceLine {
            id
            visitTypeServiceLines {
              visitTypeId
            }
          }
        }
      }
      providersByType {
        typeId
        typeName
        providers {
          id
          firstName
          lastName
          addressStreet
          addressLineTwo
          addressCity
          addressState
          addressZip
          addressCoordinates
          addressTimezone
          external
          providerTypeId
          providerType {
            id
            name
            requireStateLicense
          }
          traits {
            trait
            value
          }
          teamProviders {
            teamId
          }
          active
          serviceLineProviders {
            serviceLineId
            serviceLine {
              id
              visitTypeServiceLines {
                visitTypeId
              }
            }
          }
        }
      }
    }
    organizationalUnitOrgUser @include(if: $organizationalUnitSegmentationEnabled) {
      organizationalUnitId
      orgUser {
        providers {
          id
        }
      }
    }
    organizationalUnit @include(if: $organizationalUnitSegmentationEnabled) {
      id
      active
    }
    shift(where: {
        startTime: { gte: $start, lt: $end }
      }) @include(if: $includeShifts) {
      id
      startTime
      endTime
      providerTravel
      status
      providerId
      addressCoordinates
      addressTimezone
      manualEdits
      overflowShift
      updatedBy
      shiftCenterId
      useShiftCenterDriveTimes
    }
  }
`;
